<template>
  <header class="header">
    <div class="container-fluid">
      <div class="row between-xs middle-xs">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <logo-ores></logo-ores>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <social-links></social-links>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import SocialLinks from '@Common/SocialLinks'
import LogoOres from '@Common/LogoOres'
export default {
  components: {
    SocialLinks,
    LogoOres
  }
}
</script>
